export default __webpack_public_path__ + "media/images/fancybox/fancy_shadow_se-0668ddc3f6ee47347ecfe0cf712d2964.png";